var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('keep-alive',[(!_vm.isPurchaseSonOrder)?[(_vm.state === 0 || _vm.state === 1500 || _vm.state === 2500)?_c('launchReturn'):_c('returnInfo')]:_c('exitCarInfo')],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }